import React, { useState, useEffect, useRef } from 'react';
import './List.css';
import arBack from './Images/skip-track (2).svg';
import arfront from './Images/skip-track (3).svg';
import play from "./Images/play.svg";
import stop from "./Images/pause 1 (1).svg";
import reload from './Images/reloading.png';
import arViewer from './Images/external-link.svg';
import { arviewerLink } from '.';

const List = ({ popUp, datum, AnimateModel, description }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedStep, setSelectedStep] = useState(null);
  const intervalRef = useRef(null);
  const isPlayingRef = useRef(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const arViewerLoader = () => {
    if (arviewerLink) {
      const newTab = window.open(arviewerLink, '_blank');
      newTab.focus();
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      const previousButtonData = datum?.stepDatum?.[currentStep - 1];
      AnimateModel(currentStep - 1, previousButtonData);
      setCurrentStep((prevStep) => prevStep - 1);
    }
    
  };

  const handleNext = () => {
    const nextButtonData = datum?.stepDatum?.[currentStep + 1];

    if (nextButtonData) {
      AnimateModel(currentStep + 1, nextButtonData);
      console.log('AnimateModel triggered with data:', nextButtonData);
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePlay = () => {
    setIsPlaying(true);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    isPlayingRef.current = true;

    intervalRef.current = setInterval(() => {
      const nextButton = document.querySelector('.next-button');
      if (nextButton && isPlayingRef.current) {
        nextButton.click();
      }
    }, 12000);

    handleNext();
  };

  const handleStop = () => {
    clearInterval(intervalRef.current);
    isPlayingRef.current = false;
    setIsPlaying(false);
  };

  useEffect(() => {
    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const handleArBackClick = () => {
    if (!description) {
      const newStep = currentStep === 0 ? 0 : currentStep - 1;
      setCurrentStep(newStep);
      setSelectedStep(null);
      AnimateModel(newStep, datum?.stepDatum?.[newStep]);
    } else {
      handlePrevious();
    }
  };

  const handleArFrontClick = () => {
    setSelectedStep(null);
    handleNext();
  };

  useEffect(() => {
    const handleGripPress = (event) => {
      if (event.inputSource.handedness === 'right') {
        handleNext();
      } else if (event.inputSource.handedness === 'left') {
        handlePrevious();
      }
    };

    window.addEventListener('gamepadbuttondown', handleGripPress);

    return () => {
      window.removeEventListener('gamepadbuttondown', handleGripPress);
    };
  }, []);

  return (
    <div className="popup-container">
      {popUp ? (
        <div className="overlay">
          <div className="content">
            <div className="list">
              {datum?.stepDatum?.map((stepsCount, i) => {
                if (i !== 0)
                  return (
                    <button
                      key={i}
                      className="popup-button"
                      onClick={() => {
                        AnimateModel(i, stepsCount);
                      }}
                    >
                      {stepsCount.stepName}
                    </button>
                  );
              })}
            </div>
            <div style={{ marginInline: '' }}>
              <div>{description}</div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      <div className="popup-overlay">
        <div className="button-list">
          {datum?.stepDatum?.map((step, i) => {
            if (i !== currentStep) {
              return null;
            }
            return (
              <button
                style={{ display: 'none' }}
                key={i}
                onClick={() => AnimateModel(i, step)}
              ></button>
            );
          })}
        </div>
        <div style={{ marginInline: '' }}>
          <div>{description}</div>
        </div>
        <div className="button-group">
          <button className="previous-button" onClick={handleArBackClick}>
            <img src={arBack} className="inIcon" />
          </button>
          {currentStep < datum?.stepDatum?.length - 1 && (
            <button className="next-button" onClick={handleArFrontClick}>
              <img src={arfront} className="inIcon" />
            </button>
          )}
        </div>
        <div className="step-count">
          {currentStep}
        </div>
      </div>
    </div>
  );
};

export default List;
